import { BaseItemStore } from "../../core/BaseStore";
import type { BusinessScheduleItem } from "./BusinessScheduleItem";

export default class BusinessScheduleStore extends BaseItemStore<BusinessScheduleItem> {
  getByBusinessPlanUid(businessPlanUid: string) {
    return this.all.filter(
      (item) => item.data.businessPlanUid === businessPlanUid,
    );
  }
}
